import * as React from 'react';

import { ErrorMessage } from '@hookform/error-message';

import { Text } from '../Primitives';

export const FormFieldError = (props: React.ComponentProps<typeof ErrorMessage>) => {
  return <ErrorMessage as={<Text color="error" size="xs" role="alert" />} {...props} />;
};
